module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-map-notification"
  }, [(_vm.$slots.default) ? _c('div', {
    staticClass: "page-map-notification__text"
  }, [_vm._t("default")], 2) : _vm._e(), (_vm.$slots.action) ? _c('div', {
    staticClass: "page-map-notification__action"
  }, [_vm._t("action")], 2) : _vm._e(), (_vm.$slots.small) ? _c('small', {
    staticClass: "page-map-notification__small"
  }, [_vm._t("small")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c8e4ac","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/map/Notification.vue
// module id = b9925e0f2e8629064f2e
// module chunks = 0